import React from 'react';
import AskDialog from '../common/dialog/AskDialog';

const AskRemoveDialog = ({ visible, onConfirm, onCancle }) => {
  return (
    <AskDialog
      visible={visible}
      title="공통코드 삭제"
      description="공통코드를 삭제하시겠습니까?"
      confirmText="삭제"
      onConfirm={onConfirm}
      onCancle={onCancle}
    />
  );
};

export default AskRemoveDialog;
